<span class="table-button-container">
	<!-- CUSTOM BUTTONS -->
	<app-custom-row-actions
		[actions]="customActions"
		[row]="row"
		[rowIndex]="rowIndex"
		[isEditing]="isEditing"
		[isCanceled]="isCanceled"
		[isDeleted]="isDeleted"
		(action)="action.emit($event)">
	</app-custom-row-actions>

	<!-- EDIT action (not editing, not canceled) -->
	<button *ngIf="!isEditing && !isCanceled && hasAction(ACTION_IDS.EDIT)"
			(click)="emitAction(ACTION_IDS.EDIT)"
			class="table-button" color="primary" mat-icon-button
			matTooltip="{{ 'LABEL_EDIT' | translate }}">
		<mat-icon>edit</mat-icon>
	</button>

	<!-- EDIT action (not editing, canceled - shows search icon) -->
	<button *ngIf="!isEditing && isCanceled && hasAction(ACTION_IDS.EDIT)"
			(click)="emitAction(ACTION_IDS.EDIT)"
			class="table-button" color="primary" mat-icon-button
			matTooltip="{{ 'LABEL_SHOW_DETAIL' | translate }}">
		<mat-icon>search</mat-icon>
	</button>

	<!-- SAVE action (editing) -->
	<button *ngIf="isEditing && hasAction(ACTION_IDS.SAVE)"
			(click)="emitAction(ACTION_IDS.SAVE)"
			class="table-button" color="primary" mat-icon-button
			matTooltip="{{ 'LABEL_SAVE' | translate }}">
		<mat-icon>save</mat-icon>
	</button>

	<!-- CANCEL/EXIT action (editing or new row) -->
	<button *ngIf="isEditing && (hasAction(ACTION_IDS.EDIT) || isNewRow)"
			(click)="emitAction(ACTION_IDS.EXIT_ROW)"
			class="table-button" color="primary" mat-icon-button
			matTooltip="{{ 'LABEL_CANCEL' | translate }}">
		<mat-icon>cancel</mat-icon>
	</button>


	<!-- DELETE action (not for new rows) -->
	<button *ngIf="hasAction(ACTION_IDS.DELETE) && canDelete() && !isDeleteDisabled && !isNewRow"
			(click)="emitAction(ACTION_IDS.DELETE)"
			class="table-button" color="primary" mat-icon-button
			matTooltip="{{ 'LABEL_DELETE' | translate }}">
		<mat-icon>delete</mat-icon>
	</button>

	<!-- INNER_TABLE action -->
	<button *ngIf="hasAction(ACTION_IDS.INNER_TABLE)"
			(click)="emitAction(ACTION_IDS.INNER_TABLE)"
			class="table-button" color="primary" mat-icon-button
			matTooltip="{{ 'LABEL_INNER_TABLE' | translate }}">
		<mat-icon>{{ row?.isInnerTableVisible ? 'expand_less' : 'expand_more' }}</mat-icon>
	</button>


</span>
